import { Box, type SxProps } from '@mui/material';

export const ComponentBox = ({ children, sx }: { children: React.ReactNode; sx?: SxProps }) => (
  <Box width='100%' height='100%' display='flex' flexDirection='column' sx={{ ...sx }}>
    {children}
  </Box>
);
